import Image, { StaticImageData } from "next/image";
import { BreadCrumb, BreadCrumbProps } from "../breadcumb";
import styles from "./styles.module.scss";
import { FC } from "react";
import { MyButton } from "@/components/atoms";

export interface BlockHeaderSuperpositionProps {
  title: string;
  breadCrumbProps: BreadCrumbProps;
  textInWhiteBlock: string;
  image: StaticImageData | string;
  btnlabel: string;
  onClickBtn?: () => void;
}

export const BlockHeaderSuperposition: FC<BlockHeaderSuperpositionProps> = ({
  title,
  breadCrumbProps,
  textInWhiteBlock,
  image,
  btnlabel,
  onClickBtn,
}) => {
  return (
    <div className={styles._block}>
      <div className={styles.container}>
        <div className={styles.title_breadCrumbs}>
          <BreadCrumb className={styles.BreadCrumb} {...breadCrumbProps} />
          <h1>{title}</h1>
        </div>
        <div className={styles.hero_image_container}>
          <Image src={image} alt={title} />
        </div>
        <div className={styles.block_white}>
          <div className={styles.contents}>
            <div
              className={styles.hero_text_container}
              dangerouslySetInnerHTML={{ __html: textInWhiteBlock }}
            ></div>
            <div className={styles.btn_container}>
              <MyButton onClick={onClickBtn} label={btnlabel} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
